"use strict";
module.exports = {
    main: 'line-height:1.3;color:#748096;background:#1e1e1e;overflow:auto;',
    error: 'line-height:1.3;color:#748096;background:#1e1e1e;overflow:auto;',
    key: 'color:#b553bf;',
    string: 'color:#fba856;',
    value: 'color:#93a3bf;',
    boolean: 'color:#448aa9;',
};
